export default ({ store, router }) => {
    router.beforeEach((to, from, next) => {
        // If current route is only for authenticated users and user is not authenticated, redirect to login
        if (to.meta.auth && !store.getters['auth/isAuth']) {
            // store.dispatch('auth/signout')
            // or
            next({ name: 'Signin' })
            // If current route is only for guest and user is authenticated, redirect to home
        } else if (to.meta.guest && store.getters['auth/isAuth']) {
            next({
                name: 'AdminDashboard',
            })
        } else {
            next()
        }
    })
}
